module.exports = __webpack_public_path__ + "img/draw2_img5.7593118e.png";